import React, {FC} from 'react';

import {ReactComponent as Arrow} from '../../assets/arrow.svg';
import dayjs from 'dayjs';
import {AlertTypeIndicator} from '../alert-type-indicator/alert-type-indicator.component';
import {DataTextBody} from '../data-text-body/data-text-body.component';
import { Alert } from '../../services/api/models/Alert';

type Props = {
  alert: Alert;
  onSelect(): void;
};

export const AlertHistoryListItem: FC<Props> = ({alert, onSelect}) => (
  <div className="flex flex-row border-b border-b-gray-300 py-2">
    <div className="mx-2 flex items-center justify-center" style={{maxWidth: 80}}>
      <AlertTypeIndicator alertType={alert.alertStatus} />
    </div>
    <div className="flex flex-1 flex-col justify-center pt-1">
      <h5 className="text-xs sm:text-base">{dayjs(alert.alertDate).format('DD/MM/YYYY | HH:mm:ss')}</h5>
      <DataTextBody>{alert.alertDescription}</DataTextBody>
    </div>
    <button className="w-1/6 flex items-center justify-center" style={{maxWidth: 80}} onMouseDown={onSelect}>
      <Arrow />
    </button>
  </div>
);
